export default {
    zh: {
        // 页面标题
        pageTitle: '视频特效',
        
        // AI 亲吻工具
        aiKissingTitle: 'AI 亲吻视频生成器',
        aiKissingDesc: '让两张照片"一吻定情"',
    },
    en: {
        // Page Title
        pageTitle: 'Video Effects',
        
        // AI Kissing Tool
        aiKissingTitle: 'AI Kissing Video Generator',
        aiKissingDesc: 'Bring two photos to life with a kiss',
    },
    ja: {
        // ページタイトル
        pageTitle: '動画エフェクト',
        
        // AI キスツール
        aiKissingTitle: 'AIキス動画ジェネレーター',
        aiKissingDesc: '2枚の写真にキスで命を吹き込む',
    },
    ko: {
        // 페이지 제목
        pageTitle: '비디오 효과',
        
        // AI 키스 도구
        aiKissingTitle: 'AI 키스 영상 생성기',
        aiKissingDesc: '키스로 두 장의 사진에 생명을 불어넣기',
    },
    es: {
        // Título de la página
        pageTitle: 'Efectos de Video',
        
        // Herramienta de Besos con IA
        aiKissingTitle: 'Generador de videos de besos con IA',
        aiKissingDesc: 'Da vida a dos fotos con un beso',
    },
    fr: {
        // Titre de la page
        pageTitle: 'Effets Vidéo',
        
        // Outil de Baisers IA
        aiKissingTitle: 'Générateur de vidéos de baisers IA',
        aiKissingDesc: 'Donnez vie à deux photos avec un baiser',
    },
    de: {
        // Seitentitel
        pageTitle: 'Videoeffekte',
        
        // KI-Kuss-Tool
        aiKissingTitle: 'KI-Kuss-Video-Generator',
        aiKissingDesc: 'Erwecken Sie zwei Fotos mit einem Kuss zum Leben',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'Видеоэффекты',
        
        // Инструмент Поцелуев с ИИ
        aiKissingTitle: 'Генератор видео поцелуев с ИИ',
        aiKissingDesc: 'Оживите две фотографии поцелуем',
    },
    pt: {
        // Título da página
        pageTitle: 'Efeitos de Vídeo',
        
        // Ferramenta de Beijos com IA
        aiKissingTitle: 'Gerador de vídeos de beijos com IA',
        aiKissingDesc: 'Dê vida a duas fotos com um beijo',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Effetti Video',
        
        // Strumento di Baci con IA
        aiKissingTitle: 'Generatore di video di baci IA',
        aiKissingDesc: 'Dai vita a due foto con un bacio',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'تأثيرات الفيديو',
        
        // أداة القبلات بالذكاء الاصطناعي
        aiKissingTitle: 'مولد فيديو القبلات بالذكاء الاصطناعي',
        aiKissingDesc: 'أحيي صورتين بقبلة',
    },
    tw: {
        // 頁面標題
        pageTitle: '影片特效',
        
        // AI 親吻工具
        aiKissingTitle: 'AI 親吻影片產生器',
        aiKissingDesc: '用親吻賦予兩張照片生命',
    },
    pl: {
        // Tytuł strony
        pageTitle: 'Efekty wideo',
        
        // Narzędzie do pocałunków AI
        aiKissingTitle: 'Generator wideo pocałunków AI',
        aiKissingDesc: 'Ożyw dwa zdjęcia pocałunkiem',
    },
    th: {
        // Page Title
        pageTitle: 'เอฟเฟกต์วิดีโอ',
        
        // AI Kissing Tool
        aiKissingTitle: 'เครื่องมือสร้างวิดีโอจูบด้วย AI',
        aiKissingDesc: 'ทำให้สองภาพมีชีวิตชีวาด้วยการจูบ',
    },
    da: {
        // Page Title
        pageTitle: 'Videoeffekter',
        
        // AI Kissing Tool
        aiKissingTitle: 'AI-kyssevideogenerator',
        aiKissingDesc: 'Giv to billeder liv med et kys',
    },
    no: {
        // Page Title
        pageTitle: 'Videoeffekter',
        
        // AI Kissing Tool
        aiKissingTitle: 'AI-kyssvideogenerator',
        aiKissingDesc: 'Gi to bilder liv med et kyss',
    },
    nl: {
        // Page Title
        pageTitle: 'Video-effecten',
        
        // AI Kissing Tool
        aiKissingTitle: 'AI-kusvideogenerator',
        aiKissingDesc: "Breng twee foto's tot leven met een kus",
    },
    id: {
        // Page Title
        pageTitle: 'Efek Video',
        
        // AI Kissing Tool
        aiKissingTitle: 'Generator video ciuman AI',
        aiKissingDesc: 'Hidupkan dua foto dengan sebuah ciuman',
    },
    tr: {
        // Page Title
        pageTitle: 'Video Efektleri',
        
        // AI Kissing Tool
        aiKissingTitle: 'Yapay Zeka Öpücük Video Üreticisi',
        aiKissingDesc: 'İki fotoğrafa bir öpücükle hayat verin',
    },
}

